var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections-label"},[_c('span',{staticClass:"fa fa-caret-left"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d660ee70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/components/types/MockSectionsLabel.vue
// module id = null
// module chunks = 